import React, { useState, useEffect } from "react"
import {} from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import MetadataLayout from "../general/MetadataLayout"
import { makeStyles } from "@material-ui/core/styles"
import Modal from "@material-ui/core/Modal"
import TagsUpdateDropdown from "./TagsUpdateDropdown"
import { operationsHelper } from "../../helpers/operations"
import { documentsActions } from "../../actions/documentsActions"
import CommentsDetailsModal from "../documents/CommentsDetailsModal"
import PrevNextButtons from "../common/PrevNextButtons"
import { Typography } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

const DocumentModal = (props) => {
	const downloadDocs = useSelector((state) => state.downloads.documents)
	const currentDoc = useSelector((state) => state.documentModal.currentDocument)
	const documentLoading = useSelector((state) => state.documentModal.documentLoading)

	const alert = useSelector((state) => state.alert.alert)

	const dispatch = useDispatch()

	const [item, setItem] = useState({
		idItem: "",
		contentItem: "",
	})
	const [content, setContent] = useState({
		documentId: "",
		documentText: "",
		documentSubject: "",
		documentFrom: "",
		documentTo: "",
		errorDocumentText: null,
	})

	const {
		open,
		handleClose,
		selectDateDocument,
		wrapperRef,
		updateSelectDateDocument,
		updateSelectIdentify,
		updateDateDocument,
		showSelectDateDocument,
		maskHighlight,
		moveToHighlight,
		updateCommentCount,
	} = props

	useEffect(() => {
		if (currentDoc?.id || currentDoc?.document_id) {
			setItem({
				idItem: currentDoc.id ? currentDoc.id : currentDoc.document_id,
				contentItem: currentDoc.content,
				source: currentDoc.source,
				title: currentDoc.title,
				commentsList: currentDoc.comments,
				comments_count: currentDoc.comments_count,
				date:
					currentDoc.hasOwnProperty("tagged_date") && currentDoc.tagged_date !== null && currentDoc.tagged_date !== undefined
						? currentDoc.tagged_date
						: Math.floor(Date.now() / 1000),
				file_name: currentDoc.file_name,
				pageNum: currentDoc.hasOwnProperty("page_number") ? currentDoc.page_number : 1,
				totalPages: currentDoc.hasOwnProperty("total_page_number") ? currentDoc.total_page_number : 1,
			})

			setContent({
				documentId: currentDoc.id,
				documentSubject: currentDoc?.subject,
				documentText: currentDoc.content,
				documentFrom: currentDoc.from,
				documentTo: currentDoc?.to,
				errorDocumentText: null,
				page_number: currentDoc?.page_number,
				total_page_number: currentDoc?.total_page_number,
				author: currentDoc?.author,
				filename: currentDoc?.filename,
				file_name: currentDoc?.file_name,
				filepath: currentDoc?.filepath,
				category: currentDoc?.category,
				comments: currentDoc?.comments,
				content_status: currentDoc?.content_status,
				identifier: currentDoc?.identifier,
				keywords: currentDoc?.keywords,
				language: currentDoc?.language,
				title: currentDoc?.title,
				version: currentDoc?.version,
				parent: currentDoc?.parent || null,
				children: currentDoc?.children || [],
				cc: currentDoc?.cc || null,
				bcc: currentDoc.hasOwnProperty("bcc") ? currentDoc.bcc : [],
			})
		}
	}, [currentDoc])

	useEffect(() => {
		if (alert && alert.type === "modal" && alert.class === "alert alert-success") {
			if (selectDateDocument.date) {
				setItem({ ...item, date: new Date(selectDateDocument.date).getTime() })
			}
		}
	}, [alert])

	const useStyles = makeStyles((theme) => ({
		paper: {
			position: "absolute",
			width: "40%",
			height: "100%",
			backgroundColor: "#9dddd6",
			//border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: "16px 15px 24px",
		},
	}))

	const classes = useStyles()

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
			<div id="element_modal" style={{ top: 0, left: "60%" }} className={classes.paper}>
				<div className="col-12 divBlockModal" style={{ backgroundColor: "white" }}>
					{selectDateDocument.show ? (
						<div className="selectDateDocument" ref={wrapperRef}>
							<ul>
								<li>
									<span style={{ fontSize: "13px" }}>
										<strong>Actual date: </strong>
									</span>
									<br></br>
									<span style={{ fontSize: "14px" }}>
										{new Date(item.date).toLocaleString("en-US", {
											year: "numeric",
											month: "long",
											day: "2-digit",
										})}
									</span>
								</li>
								<li>
									<span style={{ fontSize: "13px" }}>
										<strong>New date: </strong>
									</span>
									<br></br>
									<form className="d-flex justify-content-center" onSubmit={updateDateDocument}>
										<input
											type="date"
											name="date"
											onChange={(e) => updateSelectDateDocument(e, item.idItem)}
											data-cy="date_document_input"
										/>
										<button
											type="submit"
											className={
												selectDateDocument.date ? "btn btn-primary btn-sm" : "btn btn-primary btn-sm disabled"
											}
											style={{ marginLeft: "10px" }}
											data-cy="update_modal_button"
										>
											Update
										</button>
									</form>
								</li>
							</ul>
						</div>
					) : null}

					<div className="d-flex justify-content-around">
						<div className="divBlock d-flex justify-content-around">
							<a
								data-cy="highlight_modal_button"
								onClick={(e) => {
									e.preventDefault()
									moveToHighlight()
								}}
								className="btnModal"
								style={{ textDecoration: "none" }}
							>
								<i className="bi bi-star"></i> Highlight
							</a>
						</div>
						<div className="divBlock d-flex justify-content-around">
							<TagsUpdateDropdown idItem={item.idItem} updateSelectIdentify={updateSelectIdentify} />
						</div>
						<div className="divBlock d-flex justify-content-around">
							<button
								data-cy="date_document_modal"
								className="btnModal"
								onClick={(e) => {
									showSelectDateDocument(e)
								}}
							>
								<i className="bi bi-calendar-check"></i> Date document
							</button>
						</div>

						<div className="divBlock d-flex justify-content-around">
							<button
								data-cy="download_modal_button"
								className="btnModal"
								onClick={(e) => {
									e.preventDefault()
									dispatch(documentsActions.downloadDocumentAction(item.idItem, content.file_name, item.source))
								}}
								disabled={downloadDocs.hasOwnProperty(item.idItem) && downloadDocs[item.idItem].downloading === true}
							>
								{downloadDocs.hasOwnProperty(item.idItem) && downloadDocs[item.idItem].downloading === true ? (
									<>
										<div className="spinner-border text-dark" role="status" style={{ width: "15px", height: "15px" }}>
											<span className="visually-hidden">Loading...</span>
										</div>{" "}
										Downloading...
									</>
								) : (
									<>
										<i className="bi bi-download"></i> Download
									</>
								)}
								{/* {downloadDocs.hasOwnProperty(item.idItem) && downloadDocs[item.idItem].downloading===true ?
                                    <span className="percentage"> ({downloadDocs[item.idItem].percentage}%)</span>
                                :
                                    null
                                } */}
							</button>
						</div>
						{item.totalPages && item.totalPages > 1 && (
							<div className="divBlock d-flex justify-content-around">
								<PrevNextButtons currentDocId={item.idItem} currentPage={item.pageNum} totalPages={item.totalPages} />
							</div>
						)}
					</div>
				</div>

				<div className="col-12 divBlockModal mt-1" style={{ backgroundColor: "white" }}>
					{content.errorDocumentText ? <p className="alert alert-danger">Error loading content for this document</p> : null}
					{content.documentText === null || (content.documentId !== item.idItem && content.errorDocumentText === null) ? (
						<div className="col-12 d-flex justify-content-center mt-5 mb-5">
							<div className="d-flex align-items-center alert alert-warning">
								<strong className="loading">Loading...</strong>
								<div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
							</div>
						</div>
					) : null}
					{documentLoading ? (
						<>
							<Typography component="div" variant={"h3"}>
								<Skeleton />
							</Typography>
							<Typography component="div" variant={"h3"}>
								<Skeleton />
							</Typography>
							<Typography component="div" variant={"h3"}>
								<Skeleton />
							</Typography>
							<Skeleton variant="rect" width="100%" style={{ marginTop: "20px" }}>
								<div style={{ paddingTop: "65%" }} />
							</Skeleton>
						</>
					) : (
						<div>
							<div id="divModal" className="divScroll divScrollMax655">
								{item.hasOwnProperty("source") ? (
									<MetadataLayout content={content} item={item} maskHightlight={maskHighlight}></MetadataLayout>
								) : null}
								{content?.documentText ? (
									<p
										id="document_content_div"
										style={{ whiteSpace: "pre-wrap" }}
										dangerouslySetInnerHTML={maskHighlight(content.documentText, item.idItem)}
									></p>
								) : (
									<p>No content available</p>
								)}

								<CommentsDetailsModal
									commentsCount={item.comments_count}
									commentList={item.commentsList}
									docId={item.idItem}
									updateCommentCount={updateCommentCount}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		</Modal>
	)
}

export default DocumentModal
